import { ScreenBase } from "@frui.ts/screens";
import { action, observable } from "mobx";

export interface ButtonParams {
  text?: string;
  variant?: "primary" | "danger" | "secondary";
}

export interface ConfirmDialogSettings {
  closeButton?: boolean;
  hideCancelButton?: boolean;
  hideConfirmButton?: boolean;
  requiredCheckbox?: boolean;
}

export default class ConfirmDialogViewModel extends ScreenBase {
  @observable isOpened = false;
  private onResult: (value: boolean) => void;

  get canBeNavigationActiveScreen() {
    return false;
  }

  constructor(
    public message: string,
    public title: string | undefined,
    public confirmButtonParams: ButtonParams,
    public cancelButtonParams: ButtonParams,
    public settings: ConfirmDialogSettings = {
      closeButton: true,
      hideCancelButton: false,
      hideConfirmButton: false,
      requiredCheckbox: false,
    }
  ) {
    super();
  }

  @action.bound public showConfirmation() {
    this.isOpened = true;
    return new Promise<boolean>(resolve => {
      this.onResult = resolve;
    });
  }

  @action.bound confirm() {
    this.isOpened = false;
    this.onResult(true);
  }

  @action.bound cancel() {
    this.isOpened = false;
    this.onResult(false);
  }
}
